import { pushErrorEvent, pushEventInfo, setOrderDetaillsPageInfo, } from '../analytics';
import { FULFILLMENT_TYPE } from '../../constants/status';
// const BUTTON_SUBMIT = 'button submission';
var MY_ACCT_SETTINGS = 'my account settings';
/**
 * Event analtyics for purchase history
 */
export var pushOrderDetailsNavButtonEvent = function (action) {
    return pushEventInfo({
        category: { primaryCategory: 'stash' },
        eventInfo: { eventName: MY_ACCT_SETTINGS },
        eventMode: 'stash',
        stash: { myAccount: { settings: "purchase history: ".concat(action, " button") } },
    });
};
// TODO: Not used in legacy, need to validate if order details needs this
// const pushPurchaseDetailsHeaderButtonEvent = (action: string) =>
//   pushEventInfo({
//     category: { primaryCategory: BUTTON_SUBMIT },
//     eventInfo: { eventName: MY_ACCT_SETTINGS },
//     myAccount: { settings: `purchase details: ${action}` },
//   });
export var pushOrderDetailOverlayEvent = function (eventName) {
    return pushEventInfo({
        category: { primaryCategory: 'overlay' },
        eventInfo: { eventName: eventName },
    });
};
/**
 * Error analtyics for order details
 */
export var setPurchaseDetailsPageError = function (error) {
    var _a;
    return pushErrorEvent('purchase details', ((_a = error === null || error === void 0 ? void 0 : error.status) === null || _a === void 0 ? void 0 : _a.toString()) || '', (error === null || error === void 0 ? void 0 : error.message) || '', 'page');
};
export var setViewBigReceiptError = function (error) {
    var _a, _b, _c, _d, _e, _f;
    return pushErrorEvent('purchase details view big receipt', ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.errors) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) || '', ((_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.errors) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.statusText) || '', 'inline');
};
var getFulfillmentTypesPresent = function (orderDetailsData) {
    var _a;
    var fulfillmentTypes = (_a = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.fulfillmentGroups) === null || _a === void 0 ? void 0 : _a.map(function (fulfillmentGroup) { return fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType; });
    var sth = false;
    var boss = false;
    var bopis = false;
    var bodfs = false;
    var dfs = false;
    var appliance = false;
    var misc = false;
    fulfillmentTypes === null || fulfillmentTypes === void 0 ? void 0 : fulfillmentTypes.forEach(function (fulfillmentType) {
        switch (fulfillmentType) {
            case FULFILLMENT_TYPE.STH:
                sth = true;
                break;
            case FULFILLMENT_TYPE.BODFS:
                bodfs = true;
                break;
            case FULFILLMENT_TYPE.APPLIANCE:
                appliance = true;
                break;
            case FULFILLMENT_TYPE.DFS:
                dfs = true;
                break;
            case FULFILLMENT_TYPE.BOPIS:
                bopis = true;
                break;
            case FULFILLMENT_TYPE.BOSS:
                boss = true;
                break;
            default:
                misc = true;
                break;
        }
    });
    return {
        sth: sth,
        bodfs: bodfs,
        appliance: appliance,
        dfs: dfs,
        bopis: bopis,
        boss: boss,
        misc: misc,
    };
};
// 7.13.Order Details Page Load - Authenticated
export var trackOrderDetailsPage = function (orderDetailsData) {
    var _a, _b;
    var fulfillmentTypes = getFulfillmentTypesPresent(orderDetailsData);
    var transactionId = orderDetailsData.transactionId
        ? (_a = orderDetailsData.transactionId) === null || _a === void 0 ? void 0 : _a.toString()
        : (_b = orderDetailsData.orderNumber) === null || _b === void 0 ? void 0 : _b.toString();
    var settings = "orders:sth:".concat(fulfillmentTypes.sth ? 'y' : 'n', "|boss:").concat(fulfillmentTypes.boss ? 'y' : 'n', "|bopis:").concat(fulfillmentTypes.bopis ? 'y' : 'n', "|bodfs:").concat(fulfillmentTypes.bodfs ? 'y' : 'n', "|appl:").concat(fulfillmentTypes.appliance ? 'y' : 'n', "|unknown:").concat(fulfillmentTypes.misc || fulfillmentTypes.dfs ? 'y' : 'n');
    setOrderDetaillsPageInfo({
        pageInfo: {
            pageName: 'account>purchase history>order details',
            pageType: 'maml:orders',
            pageLoadEvent: 'order view',
        },
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>purchase history',
            subCategory2: 'account>purchase history>order details',
        },
        myAccount: {
            settings: settings,
        },
    }, transactionId, {
        primaryCategory: 'account',
        subCategory1: 'account>purchase history>order details',
        subCategory2: 'account>purchase history>order details',
    });
};
/** `Purchase History - Order Details - Track Delivery Button Clicked` */
export var pushDeliveryTrackerButtonClickedEvent = function () {
    return pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: MY_ACCT_SETTINGS },
        myAccount: {
            settings: 'purchase history: order details: track delivery',
        },
    });
};
